// extracted by mini-css-extract-plugin
export default {"detailed-event-news-page":"DetailedEventNewsPage_detailed-event-news-page__Gbl8k","sections-list":"DetailedEventNewsPage_sections-list__2R8NY"};